module.exports = __webpack_public_path__ + "img/hr-sand-decal-12.f79beff7.png";